// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableMobileRowContent_box__2vozO {\n  padding: 0px 18px 15px 20px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Table/TableMobileRowContent.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B","sourcesContent":[".box {\n  padding: 0px 18px 15px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": "TableMobileRowContent_box__2vozO"
};
export default ___CSS_LOADER_EXPORT___;
